// extracted by mini-css-extract-plugin
export var container = "_75-0";
export var error = "_75-9";
export var label = "_75-5";
export var light = "_75-6";
export var md = "_75-3";
export var sm = "_75-2";
export var thin = "_75-8";
export var thinBold = "_75-7";
export var vertical = "_75-4";
export var xs = "_75-1";